import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { initialGetUserState } from '../initial-states/getUser.initialState';
import { initialLoginState } from '../initial-states/userLogIn.initialState';
import type { CoreUserDDB } from '../interfaces/user.interface';

// Slice
export const userSlice = createSlice({
  name: 'userStore',
  initialState: {
    loggedInUser: initialLoginState,
    user: initialGetUserState,
    success: false,
    loginUserInit: false,
    deleteAccount: false,
    getUserInit: false,
    updateUserInit: false,
  },
  reducers: {
    LOGIN_USER_INIT: (state) => {
      state.loginUserInit = true;
    },
    LOGIN_USER_SUCCESS: (state, action: PayloadAction<CoreUserDDB>) => {
      // @ts-ignore
      state.loggedInUser = action.payload;
      // @ts-ignore
      state.user = action.payload;
      state.success = true;
      state.loginUserInit = false;
    },
    HYDRATE_USER_SUCCESS: (state, action: PayloadAction<CoreUserDDB>) => {
      // @ts-ignore — userStore is loosely typed (matches LOGIN_USER_SUCCESS)
      state.user = action.payload;
      // @ts-ignore — TextEditor / EditDraftFormRender read loggedInUser
      // independently of user. Mirror LOGIN_USER_SUCCESS by setting both
      // so reload doesn't leave draftsRoute pointing at /user//drafts.
      state.loggedInUser = action.payload;
    },
    DELETE_ACCOUNT_INIT: (state) => {
      state.deleteAccount = true;
    },
    DELETE_ACCOUNT_SUCCESS: (state, action: PayloadAction<boolean>) => {
      state.deleteAccount = action.payload;
    },
    GET_USER_INIT: (state) => {
      state.getUserInit = true;
    },
    // biome-ignore lint/suspicious/noExplicitAny: user payload shape is loosely typed (legacy); tighten during Apollo migration
    GET_USER_SUCCESS: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
      state.getUserInit = false;
    },
    // biome-ignore lint/suspicious/noExplicitAny: user payload shape is loosely typed (legacy); tighten during Apollo migration
    REFRESH_USER_INIT: (state, action: PayloadAction<any>) => {
      state.updateUserInit = action.payload;
    },
    // biome-ignore lint/suspicious/noExplicitAny: user payload shape is loosely typed (legacy); tighten during Apollo migration
    REFRESH_USER_SUCCESS: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
      state.updateUserInit = false;
    },
    UPDATE_USER_INIT: (state, action: PayloadAction<boolean>) => {
      state.updateUserInit = action.payload;
    },
    // biome-ignore lint/suspicious/noExplicitAny: user payload shape is loosely typed (legacy); tighten during Apollo migration
    UPDATE_USER_SUCCESS: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
      state.updateUserInit = false;
    },
    UPDATE_USER: (state, action: PayloadAction<any>) => {
      state.user = action.payload;
    },
    UPDATE_LOGGED_IN_USER: (state, action: PayloadAction<any>) => {
      state.loggedInUser = action.payload;
    },
  },
});

export default userSlice.reducer;
